export default class Subdomains  {
    static async loadSettings() {        
        return (
            fetch('/preset.json')
            .then(res => {
                try {
                    return res.json()
                } catch (e) {
                    console.log(e);
                }
            })
            .catch(e => {console.log(e)})
        )
    }
}